import React from 'react';

import { IQuestion } from 'modules/national-certificate';

import TextSection from './input-test/text-section';
import Options from './options';
import TopSection from './top-section';

interface IProps {
  data?: IQuestion;
}

const SimpleQuestion: React.FC<IProps> = ({ data }) => (
  <div className="shadow-xs space-y-3 rounded-xl bg-white px-4 py-3">
    <div className="px-1">
      <TopSection testImage={data?.image} questionId={data?.question_id} title={data?.question_name} />
    </div>
    {data?.description ? <TextSection description={data?.description} /> : null}
    <Options testId={data?.id} options={data?.options} isHorizontal />
  </div>
);

export default SimpleQuestion;
